import * as React from 'react';
import {
    WrappedFieldProps
} from "redux-form";
import FormGroupInput from "./form_group_input";

interface IProps {
    type: string;
    placeholder: string;
    name: string;
    label: string;
    require?: boolean;
    unit?: string;
}

const FormGroupInputConnectRf: React.FC<IProps & WrappedFieldProps> = (props) => {

    const {type, placeholder, name, label, input, meta, require, unit} = props;

    const hasError = !!meta.error && !!meta.touched;

    return (
        <FormGroupInput
            type={type}
            placeholder={placeholder}
            name={name}
            label={label}
            input={input}
            hasError={hasError}
            errorText={props.meta.error}
            require={require}
            unit={unit}
            />
    );
};

export default (FormGroupInputConnectRf);


// WEBPACK FOOTER //
// ./src/presentation/common/molecular/form_group/form_group_input_connect_rf.tsx